import AmiStrings from '../strings.js';

export default function AmiChannelsSidebar() {
    var sbName = 'chanList';
    var body = <div />;
    var activeChannel = undefined;

    var setTitle;
    var rowEven = false;

    var createChannel = function(channelInfo) {
        var toString = function() {
            var str = '';

            if(channelInfo.hasPassword())
                str += '*';
            if(channelInfo.isTemporary())
                str += '[';
            str += channelInfo.getName();
            if(channelInfo.isTemporary())
                str += ']';

            return str;
        };

        var nameElem = <div style={{ display: 'block' }}>{toString()}</div>;
        var elem = <div class={rowEven ? 'rowEven' : 'rowOdd'}>{nameElem}</div>;

        rowEven = !rowEven;

        return {
            getElement: function() {
                return elem;
            },
            setActive: function(state) {
                elem.style.fontWeight = state ? 'bold' : null;
            },
            update: function() {
                nameElem.textContent = toString();
            },
        };
    };

    return {
        getName: function() { return sbName; },
        isWide: function() { return false; },
        getBody: function() { return body; },
        apply: function(obj) {
            setTitle = obj.setTitle;
        },
        reloadStrings: function() {
            setTitle(AmiStrings.getMenuString('chans'));
        },
        add: function(channelInfo) {
            //
        },
        update: function(name, channelInfo) {
            //
        },
        remove: function(name) {
            //
        },
        switch: function(name) {
            //
        },
    };
};
